<template lang="html">
  <el-form :model="ruleForm" ref="ruleForm" label-width="" class="search-form">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item label="" prop="createTime">
          <el-date-picker
            v-model="ruleForm.createTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="timestamp"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-row>
          <el-col :span="11">
            <el-form-item label="" prop="totalMoney.start">
              <el-input
                v-model="ruleForm.totalMoney.start"
                type="number"
                placeholder="最小金额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="join-line-wrap">
            <span class="join-line">--</span>
          </el-col>
          <el-col :span="11">
            <el-form-item label="" prop="totalMoney.end">
              <el-input
                v-model="ruleForm.totalMoney.end"
                type="number"
                placeholder="最大金额"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4">
        <el-button type="default" @click="doReset">重置</el-button>
        <el-button type="primary" @click="doSearch">搜索</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    doReset() {
      this.$refs.ruleForm.resetFields();
      this.$emit("search");
    },
    doSearch() {
      this.$emit("search");
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss">
.search-form {
  margin-top: 20px;
  margin-bottom: 20px;
  .join-line-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 34px;
  }
  .same-date-picker {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/flowingWater/components/searchForm/index.vue